import { render, staticRenderFns } from "./InitLayout.vue?vue&type=template&id=18e523ab&scoped=true&"
import script from "./InitLayout.vue?vue&type=script&lang=js&"
export * from "./InitLayout.vue?vue&type=script&lang=js&"
import style0 from "./InitLayout.vue?vue&type=style&index=0&id=18e523ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e523ab",
  null
  
)

export default component.exports